import { render, staticRenderFns } from "./AddressValidator.vue?vue&type=template&id=5591ce31"
import script from "./AddressValidator.vue?vue&type=script&lang=js"
export * from "./AddressValidator.vue?vue&type=script&lang=js"
import style0 from "./AddressValidator.vue?vue&type=style&index=0&id=5591ce31&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports